import { OrderTypes } from 'src/constants/orderListConstants';

const Filter = (array, constant) =>
    array.filter(
        (item) => item.orderType?.trim().toLowerCase() === constant?.toLowerCase()
    );

const mergeArray = (tissueArray, nonTissueArray) => {
    let usageArray =
        tissueArray && Filter(tissueArray, OrderTypes().USAGE_TISSUE);

    let nonUsageArray =
        tissueArray && Filter(tissueArray, OrderTypes().TISSUE_SERVICES);

    let surgeryOrderArray =
        tissueArray && Filter(tissueArray, OrderTypes().SURGERY_ORDER);

    nonTissueArray &&
        usageArray.push(
            ...Filter(nonTissueArray, OrderTypes().USAGE_NON_TISSUE)
        );

    nonTissueArray &&
        nonUsageArray.push(...Filter(nonTissueArray, OrderTypes().NON_TISSUE));

    nonTissueArray &&
        nonUsageArray.push(
            ...Filter(nonTissueArray, OrderTypes().SURGERY_ORDER)
        );
    nonTissueArray &&
        nonUsageArray.push(
            ...Filter(nonTissueArray, OrderTypes().MAST_ORDER)
        );

    nonTissueArray &&
        nonUsageArray.push(
            ...Filter(nonTissueArray, OrderTypes().CONSIGNMENTBILLING_ORDER)
        );

    tissueArray &&
        nonUsageArray.push(
            ...Filter(tissueArray, OrderTypes().CONSIGNMENTBILLING_ORDER)
        );
    tissueArray &&
        nonUsageArray.push(
            ...Filter(tissueArray, OrderTypes().CONSIGNMENTADD_ORDER)
        );
    nonTissueArray &&
        nonUsageArray.push(
            ...Filter(nonTissueArray, OrderTypes().CONSIGNMENTADD_ORDER)
        );

    nonTissueArray &&
        nonUsageArray.push(...Filter(nonTissueArray, OrderTypes().USAGE_ORDER));
    nonTissueArray &&
        nonUsageArray.push(...Filter(nonTissueArray, OrderTypes().DEMO_ORDER));
    nonTissueArray &&
        nonUsageArray.push(
            ...Filter(nonTissueArray, OrderTypes().CAPITAL_EQUIPMENT_ORDER)
        );
    nonTissueArray &&
        nonUsageArray.push(
            ...Filter(nonTissueArray, OrderTypes().WARRANTY_REPLACE)
        );
    nonTissueArray &&
        nonUsageArray.push(
            ...Filter(nonTissueArray, OrderTypes().CONSIGNMENT_TRANSFER)
        );
    nonTissueArray &&
        nonUsageArray.push(...Filter(nonTissueArray, OrderTypes().CREDIT));
    nonTissueArray &&
        nonUsageArray.push(...Filter(nonTissueArray, OrderTypes().DEBIT));
     nonTissueArray &&
        nonUsageArray.push(...Filter(nonTissueArray, OrderTypes().MAST_USAGE));
    
    nonTissueArray &&
        nonUsageArray.push(...Filter(nonTissueArray, OrderTypes().MAST_REPLENISHMENT));

    const orderArray = usageArray.concat(nonUsageArray);

    const totalOrderArray = orderArray.concat(surgeryOrderArray);

    const unmatchedOrders = [...(tissueArray || []), ...(nonTissueArray || [])].filter(
        (order) => !totalOrderArray.includes(order)
    );

    return totalOrderArray.concat(unmatchedOrders);
};

export default mergeArray;
